import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Plus, Trash2, Edit } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '../../components/ui/dialog';
import { Switch } from '../../components/ui/switch';
import { toast } from '../../hooks/use-toast';

import { API } from '../../config';

const AdminRestaurants = () => {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', station: '', cuisines: '', price: 249, minOrder: 150, veg: true, rating: 4.2, time: '30-40 min', image: '', fssai: '' });

  const t = () => localStorage.getItem('tp_admin_token');
  const load = async () => {
    const r = await axios.get(`${API}/admin/restaurants`, { headers: { Authorization: `Bearer ${t()}` } });
    setList(r.data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name || !form.station) { toast({ title: 'Name & station required' }); return; }
    const payload = { ...form, cuisines: form.cuisines.split(',').map(c=>c.trim()).filter(Boolean) };
    await axios.post(`${API}/admin/restaurants`, payload, { headers: { Authorization: `Bearer ${t()}` } });
    setOpen(false);
    setForm({ name: '', station: '', cuisines: '', price: 249, minOrder: 150, veg: true, rating: 4.2, time: '30-40 min', image: '', fssai: '' });
    load();
  };
  const del = async (id) => {
    if (!window.confirm('Delete restaurant?')) return;
    await axios.delete(`${API}/admin/restaurants/${id}`, { headers: { Authorization: `Bearer ${t()}` } });
    load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl font-bold text-[#0B2E5C]">Manage Restaurants</h1>
          <p className="text-sm text-gray-500">{list.length} restaurants registered</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-tp-orange hover:bg-[#E07A0F] text-white font-semibold"><Plus size={16} className="mr-1" /> Add Restaurant</Button></DialogTrigger>
          <DialogContent className="max-w-2xl">
            <DialogHeader><DialogTitle>Add Restaurant</DialogTitle></DialogHeader>
            <div className="grid grid-cols-2 gap-3">
              {[['name','Name'],['station','Station Code'],['cuisines','Cuisines (comma sep)'],['fssai','FSSAI Lic'],['image','Image URL'],['time','Delivery Time']].map(([k,l]) => (
                <div key={k}><label className="text-xs font-semibold uppercase text-gray-500">{l}</label><Input value={form[k]} onChange={e=>setForm({...form, [k]: e.target.value})} /></div>
              ))}
              <div><label className="text-xs font-semibold uppercase text-gray-500">Min Order</label><Input type="number" value={form.minOrder} onChange={e=>setForm({...form, minOrder: +e.target.value})} /></div>
              <div><label className="text-xs font-semibold uppercase text-gray-500">Price for Two</label><Input type="number" value={form.price} onChange={e=>setForm({...form, price: +e.target.value})} /></div>
              <div><label className="text-xs font-semibold uppercase text-gray-500">Rating</label><Input type="number" step="0.1" value={form.rating} onChange={e=>setForm({...form, rating: +e.target.value})} /></div>
              <div className="flex items-center gap-3 mt-5"><span className="text-sm font-semibold">Pure Veg</span><Switch checked={form.veg} onCheckedChange={v=>setForm({...form, veg: v})} /></div>
            </div>
            <DialogFooter><Button onClick={add} className="bg-tp-orange hover:bg-[#E07A0F] text-white">Save</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 card-shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
            <tr><th className="text-left py-3 px-4">Name</th><th className="text-left py-3 px-4">Station</th><th className="text-left py-3 px-4">Cuisines</th><th className="text-left py-3 px-4">Rating</th><th className="text-left py-3 px-4">FSSAI</th><th></th></tr>
          </thead>
          <tbody>
            {list.map(r => (
              <tr key={r.id} className="border-t">
                <td className="py-3 px-4"><div className="flex items-center gap-2"><img src={r.image} alt="" className="w-8 h-8 rounded object-cover" /><span className="font-semibold">{r.name}</span></div></td>
                <td className="py-3 px-4">{r.station}</td>
                <td className="py-3 px-4 text-xs text-gray-500">{r.cuisines?.join(', ')}</td>
                <td className="py-3 px-4">{r.rating}</td>
                <td className="py-3 px-4 text-xs">{r.fssai}</td>
                <td className="py-3 px-4 text-right"><button onClick={()=>del(r.id)} className="text-red-500 hover:bg-red-50 p-1.5 rounded"><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {list.length === 0 && <div className="text-center py-10 text-gray-400">No restaurants yet</div>}
      </div>
    </div>
  );
};

export default AdminRestaurants;
